import { render, staticRenderFns } from "./taskDetailDlg.vue?vue&type=template&id=1ed23112&scoped=true"
import script from "./taskDetailDlg.vue?vue&type=script&lang=js"
export * from "./taskDetailDlg.vue?vue&type=script&lang=js"
import style0 from "./taskDetailDlg.vue?vue&type=style&index=0&id=1ed23112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed23112",
  null
  
)

export default component.exports